/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderCreateRequestDto } from '../../models/order-create-request-dto';
import { OrderStoreResponse } from '../../models/order-store-response';

export interface PostOrderCreate$Params {
      body: OrderCreateRequestDto
}

export function postOrderCreate(http: HttpClient, rootUrl: string, params: PostOrderCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<OrderStoreResponse>> {
  const rb = new RequestBuilder(rootUrl, postOrderCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrderStoreResponse>;
    })
  );
}

postOrderCreate.PATH = '/v1/order';
